import { createGlobalStyle } from 'styled-components';

/**
 * Styles globaux synchronisés avec data-theme / ThemeProvider.
 * Complète themeTokens.css pour le hors styled-components.
 */
const GlobalThemeStyles = createGlobalStyle`
  html,
  body,
  #root {
    background-color: var(--ucp-bg-page);
    color: var(--ucp-text);
  }

  .App {
    background-color: var(--ucp-bg-page);
    color: var(--ucp-text);
    min-height: 100vh;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--ucp-bg-page);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--ucp-border);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--ucp-text-muted);
  }

  input:not([type='checkbox']):not([type='radio']):not([type='range']),
  select,
  textarea {
    background-color: var(--ucp-input-bg);
    color: var(--ucp-text);
    border-color: var(--ucp-input-border);
  }

  input::placeholder,
  textarea::placeholder {
    color: var(--ucp-text-muted);
  }

  .ucp-themed-card {
    background: var(--ucp-bg-card);
    color: var(--ucp-text);
    border: 1px solid var(--ucp-border);
    box-shadow: var(--ucp-shadow);
  }
`;

export default GlobalThemeStyles;
